// Lib
import React from 'react';

// Components
import ImageModalV2Editor from './ImageModalV2Editor';

import { intercomTrackEvent } from '../../../../../analytics/intercomService';

// Types
import { ImageModalV2EditModeProps } from '../imageModalV2Types';

type ImageModalV2CropModeContentProps = ImageModalV2EditModeProps & {
    toolbarMode: 'edit' | 'background';
    boundsWidth: number;
    boundsHeight: number;
    captionHeight: number;
};

/**
 * V2 crop entry point: maps the measured V2 image bounds onto editor viewport props.
 */
const ImageModalV2CropModeContent: React.FC<ImageModalV2CropModeContentProps> = ({
    boundsWidth,
    boundsHeight,
    captionHeight,
    toolbarMode,
    gridSize,
    ...editModeProps
}) => {
    const idealHeight = boundsHeight + captionHeight;
    const { finishEditingMode } = editModeProps;

    const closeEditorCallback = () => {
        intercomTrackEvent('edited-image');

        setTimeout(finishEditingMode, 50);
    };

    return (
        <ImageModalV2Editor
            {...editModeProps}
            gridSize={gridSize}
            windowWidth={boundsWidth}
            windowHeight={idealHeight}
            idealHeight={idealHeight}
            editorBounds={{ width: boundsWidth, height: boundsHeight }}
            cancelEditing={finishEditingMode}
            afterSaveCb={closeEditorCallback}
            toolbarMode={toolbarMode}
        />
    );
};

export default ImageModalV2CropModeContent;
